import React from 'react';
import RobotStatus from '../../../models/robots/robot-status';
import CleaningDataAlerts from './CleaningDataAlerts';
import CustomLocalizationType from '../../../models/enums/custom-localization-type';

const RobotStatusLists: React.FC<{ status: RobotStatus | null }> = ({ status }) => {
  if (status == null) return null;

  return (
    <React.Fragment>
      {status.activeErrors.length > 0 && (
        <CleaningDataAlerts
          titleKey={'label-Error'}
          category={CustomLocalizationType.ERROR_CODE}
          alerts={status.activeErrors}
        />
      )}
      {status.activeMaintenances.length > 0 && (
        <CleaningDataAlerts
          titleKey={'label-Maintenance'}
          category={CustomLocalizationType.MAINTENANCE_CODE}
          alerts={status.activeMaintenances}
        />
      )}
      {status.activeWarnings.length > 0 && (
        <CleaningDataAlerts
          titleKey={'label-Warning'}
          category={CustomLocalizationType.WARNING_CODE}
          alerts={status.activeWarnings}
        />
      )}
    </React.Fragment>
  );
};

export default RobotStatusLists;
